// Phase 5A — shared option lists for the Inventory page.
//
// Kept small and data-only so the page components stay focused on
// rendering + event wiring.
//
// "__all__" is a sentinel for the no-filter option. Radix UI's
// <Select.Item> rejects empty-string values (reserved for the
// "show placeholder" state), so the filter component converts
// __all__ <-> "" at the API boundary.
export const ALL_VALUE = '__all__';

export const CATEGORY_OPTIONS = [
  { value: '__all__', label: 'All categories' },
  { value: 'vehicle', label: 'Vehicle' },
  { value: 'atv', label: 'ATV' },
  { value: 'side_by_side', label: 'Side-by-Side' },
  { value: 'boat', label: 'Boat' },
  { value: 'snowmobile', label: 'Snowmobile' },
  { value: 'rv', label: 'RV' },
];

export const CONDITION_OPTIONS = [
  { value: '__all__', label: 'Any condition' },
  { value: 'new', label: 'New' },
  { value: 'used', label: 'Used' },
  { value: 'unknown', label: 'Unknown' },
];

export const AVAILABILITY_OPTIONS = [
  { value: '__all__', label: 'Any availability' },
  { value: 'available', label: 'Available' },
  { value: 'pending', label: 'Pending' },
  { value: 'sold', label: 'Sold' },
  { value: 'unknown', label: 'Unknown' },
];

export const FRESHNESS_OPTIONS = [
  { value: '__all__', label: 'Any freshness' },
  { value: 'fresh', label: 'Fresh (< 48h)' },
  { value: 'aging', label: 'Aging (2–7d)' },
  { value: 'stale', label: 'Stale (> 7d)' },
  { value: 'unknown', label: 'Unknown' },
];

export const FRESHNESS_COLORS = {
  fresh: 'bg-green-100 text-green-800',
  aging: 'bg-yellow-100 text-yellow-800',
  stale: 'bg-red-100 text-red-800',
  unknown: 'bg-gray-100 text-gray-800',
};

export const AVAILABILITY_COLORS = {
  available: 'bg-green-100 text-green-800',
  pending: 'bg-yellow-100 text-yellow-800',
  sold: 'bg-gray-200 text-gray-800',
  unknown: 'bg-gray-100 text-gray-800',
};

// Phase 5A.1 — confidence badge colour + filter options.
export const CONFIDENCE_OPTIONS = [
  { value: '__all__', label: 'Any confidence' },
  { value: 'high', label: 'High' },
  { value: 'medium', label: 'Medium' },
  { value: 'low', label: 'Low' },
];

export const CONFIDENCE_COLORS = {
  high: 'bg-emerald-100 text-emerald-800',
  medium: 'bg-amber-100 text-amber-800',
  low: 'bg-rose-100 text-rose-800',
};

// Phase 5A.2 — agent-usability flag + option list for the filter.
// Uses a string-keyed option list (true/false/"") so it plugs into
// the existing Select component the same way the confidence filter does.
export const AGENT_USABLE_OPTIONS = [
  { value: '__all__', label: 'Any usability' },
  { value: 'true', label: 'Usable' },
  { value: 'false', label: 'Not usable' },
];

export const AGENT_USABLE_COLORS = {
  true: 'bg-gold/10 text-gold-700 dark:text-gold-100',
  false: 'bg-slate-200 text-slate-700',
};

// Phase 5B — sync-run status pills for the Inventory page panel.
export const SYNC_STATUS_COLORS = {
  queued: 'bg-gray-100 text-gray-800',
  running: 'bg-sky-100 text-sky-800',
  completed: 'bg-emerald-100 text-emerald-800',
  partial: 'bg-amber-100 text-amber-800',
  failed: 'bg-rose-100 text-rose-800',
};
